/**
 * @license
 * Copyright (c) %FIRST_YEAR% %CURRENT_YEAR%, Oracle and/or its affiliates. All rights reserved.
 * https://www.oracle.com/contracts/docs/cloud_csa_online_v062223_us_eng.pdf?download=false&er=221886
 * @ignore
 */
// DO NOT MODIFY THIS FILE MANUALLY!
// This file is automatically generated based on the corresponding SVG image in
// the packages/oraclejet-preact/resources/icons folder.
import { ComponentProps } from 'preact';
import { Icon } from '../../UNSAFE_Icon';
type Props = Omit<ComponentProps<typeof Icon>, 'viewBox' | 'children'>;
const SvgEntertainment = (props: Props) => (
  <Icon viewBox="0 0 24 24" {...props}>
    <g fill="none">
      <path
        d="M11.697 2.344a1.502 1.502 0 0 1 2.082.971l1.084 4.046c.878 3.278-.947 6.69-4.186 7.558-3.24.868-6.527-1.175-7.405-4.452L2.188 6.42a1.502 1.502 0 0 1 1.317-1.88c2.158-.195 3.224-.31 4.235-.58 1.01-.272 1.99-.706 3.957-1.615zm.304 2.062c-1.615.743-2.653 1.192-3.744 1.484-1.09.292-2.213.423-3.984.587l.93 3.472c.614 2.29 2.86 3.6 4.956 3.039 2.095-.562 3.385-2.82 2.772-5.11zm-4.102 4.01a1 1 0 1 1-1.932.518A1 1 0 0 1 7.9 8.417zm3.157.19a1 1 0 1 0-.518-1.932 1 1 0 0 0 .518 1.932zm-1.059 3.33c1.067-.285 1.658-1.35 1.367-2.436L7.5 10.535c.291 1.087 1.43 1.688 2.497 1.402zm6.865-1.014a8.294 8.294 0 0 1-.693 1.89c.176.045.355.086.539.123.882.18 1.874.289 3.266.418l-.93 3.472c-.614 2.29-2.86 3.6-4.955 3.039-1.444-.387-2.505-1.58-2.825-3.032a7.878 7.878 0 0 1-1.98.288c.43 2.196 2.009 4.065 4.287 4.675 3.239.868 6.526-1.175 7.405-4.452l1.084-4.046a1.501 1.501 0 0 0-1.316-1.882c-1.737-.157-2.764-.261-3.635-.44a10.325 10.325 0 0 1-.248-.053zm.194 5.596a1 1 0 1 0 .517-1.932 1 1 0 0 0-.518 1.932zm-2.059.013c1.067.285 1.658 1.35 1.367 2.436L12.5 17.932c.291-1.087 1.43-1.687 2.497-1.401z"
        fill="currentcolor"
      />
    </g>
  </Icon>
);
export { SvgEntertainment as Entertainment };
